<template>
  <div class="playing">
    <div v-if="isPlaying">
      <h1 @click="action('play')">Play</h1>
      <hr>
      <h1 @click="action('pause')">Pause</h1>
      <hr>
      <h1 @click="action('next')">Next</h1>
      <hr>
      <h1 @click="action('stop')">Stop</h1>
    </div>
    <div v-else>
      <h1>You're not currently watching anything</h1>
    </div>
  </div>
</template>

<script>

import config from '../config'

export default {
  name: 'Playing',
  data () {
    return {
      isPlaying: false
    }
  },
  methods: {
    action(action) {
        const token = localStorage.getItem('token');

        this.axios.get(config.api + '/' + action, {
          headers: {
            'authorization': token
          }
        })
    },
    getPlaying(){
        const token = localStorage.getItem('token');

        this.axios.get(config.api + '/playing', {
          headers: {
            'authorization': token
          }
        })
        .then(result => {
          this.isPlaying = result.data.isPlaying;
        })
    }
  },
  created() {
    this.getPlaying();

    this.interval = setInterval(() => {
      this.getPlaying();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Playing.vue